import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const { 
  FiPlay, FiCheck, FiStar, FiUsers, FiTrendingUp, FiTarget, 
  FiClock, FiGift, FiShield, FiPhone, FiMail, FiChevronDown,
  FiArrowRight, FiZap, FiDollarSign, FiBookOpen, FiAward, FiX, FiCalendar,
  FiBarChart3, FiCrown, FiTrophy, FiDiamond, FiLock, FiUnlock, FiShoppingBag,
  FiMapPin, FiBriefcase, FiPhoneCall, FiMessageCircle, FiBot, FiScissors,
  FiCamera, FiHeart, FiEye, FiImage, FiInstagram, FiShirt, FiHeadphones,
  FiMonitor, FiSmartphone, FiMic, FiVideo, FiEdit3, FiLayout, FiGlobe,
  FiMegaphone, FiSend, FiActivity, FiMousePointer
} = FiIcons;

function App() {
  // Evergreen timer that resets every 15 minutes
  const [bonusTimeLeft, setBonusTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [seatsLeft] = useState(42);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setBonusTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { minutes: prev.minutes - 1, seconds: 59 };
        } else {
          // Reset to 15 minutes when timer reaches zero
          return { minutes: 14, seconds: 59 };
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "Digital Marketing Freelancer & Agency Owner",
      result: "₹85+ Lakhs Revenue",
      period: "5 Months",
      quote: "AI bot என்னோட client appointments-ஐ 24/7 handle பண்ணுது. Daily 300+ marketing inquiries automatically qualify ஆகுது!",
      rating: 5,
      multiplier: "15X More Appointments",
      experience: "6 Years Digital Marketing"
    },
    {
      name: "Priya Sharma", 
      role: "Social Media Marketing Expert & Consultant",
      result: "₹2.8 Crore Sales",
      period: "4 Months",
      quote: "AI automation use பண்ணி lead generation, client follow-ups எல்லாம் automated. Client conversion 500% increase!",
      rating: 5,
      multiplier: "500% Conversion",
      experience: "8 Years Marketing Experience"
    },
    {
      name: "Arjun Reddy",
      role: "Performance Marketing Specialist & Coach",
      result: "₹1.5 Cr Revenue",
      period: "3 Months", 
      quote: "Small freelancer-ஆ இருந்தாலும் AI-ன் help-ல 150+ clients simultaneously handle பண்ண முடியுது. Total game changer!",
      rating: 5,
      multiplier: "150X Client Capacity",
      experience: "7 Years Performance Marketing"
    }
  ];

  const bonuses = [
    {
      title: "Digital Marketing AI Assistant",
      value: "₹55,000",
      description: "Custom AI chatbot that qualifies leads, schedules appointments, and provides marketing consultation 24/7",
      icon: FiBot,
      premium: true
    },
    {
      title: "Client Appointment Automation",
      value: "₹45,000", 
      description: "Automated lead qualification system with WhatsApp & email integration for seamless client booking",
      icon: FiCalendar,
      premium: true
    },
    {
      title: "Smart CRM & Lead Tracker",
      value: "₹35,000",
      description: "AI-powered lead management with automated follow-ups and performance analytics for marketers",
      icon: FiBarChart3,
      premium: false
    },
    {
      title: "Marketing Campaign Analyzer",
      value: "₹28,000",
      description: "AI tool for campaign optimization, ROI tracking, and client reporting automation",
      icon: FiTrendingUp,
      premium: false
    }
  ];

  const faqs = [
    {
      question: "Digital marketing business-க்கு AI எப்படி helpful ஆகும்?",
      answer: "AI bots உங்க leads-ஐ 24/7 qualify பண்ணும், appointments schedule பண்ணும், marketing strategies suggest பண்ணும், client reports automate பண்ணும். Manual work 90% reduce ஆகும்!"
    },
    {
      question: "Technical knowledge இல்லாம AI tools use பண்ண முடியுமா?",
      answer: "Absolutely! நம்ம workshop-ல simple drag-and-drop tools மட்டும் தான் use பண்ணுவோம். Coding knowledge வேண்டாம். Digital marketers & freelancers-க்கு specially designed!"
    },
    {
      question: "Existing clients-ஐ AI system-ல integrate பண்ண முடியுமா?",
      answer: "Yes! உங்க current client database, email lists, WhatsApp contacts எல்லாம் AI system-ல easily import பண்ணலாம். Existing workflow-ல seamlessly integrate ஆகும்."
    },
    {
      question: "ROI எவ்வளவு நாள்ல expect பண்ணலாம்?",
      answer: "First month-ல setup complete, second month-ல lead automation start, third month-ல significant ROI. 97% digital marketers 12X revenue increase achieve பண்ணியிருக்காங்க!"
    },
    {
      question: "Multiple marketing services handle பண்ண முடியுமா?",
      answer: "Definitely! SEO, SEM, Social Media, Content Marketing, Email Marketing - எல்லா services-ம் handle பண்ணும். Multiple clients simultaneously manage பண்ணலாம்!"
    }
  ];

  // Handle registration button click
  const handleRegistration = () => {
    window.open('https://abdul.cc/10xaipay', '_blank');
  };

  // Floating elements for premium feel
  const FloatingElement = ({ children, delay = 0 }) => (
    <motion.div
      animate={{
        y: [-10, 10, -10],
        rotate: [-1, 1, -1],
      }}
      transition={{
        duration: 6,
        repeat: Infinity,
        delay,
        ease: "easeInOut"
      }}
    >
      {children}
    </motion.div>
  );

  // Mobile-Optimized Sticky Button
  const StickyButton = () => (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-3 bg-gradient-to-t from-black via-black/95 to-transparent backdrop-blur-sm border-t border-red-400/20">
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={handleRegistration}
        className="w-full bg-gradient-to-r from-red-600 via-red-700 to-red-800 text-white font-black py-4 px-6 rounded-2xl text-base shadow-2xl flex items-center justify-center gap-2 border-2 border-red-300 mobile-btn"
        style={{
          background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 25%, #b91c1c 50%, #dc2626 75%, #ef4444 100%)',
          backgroundSize: '300% 300%',
          animation: 'gradient-shift 3s ease infinite'
        }}
      >
        <SafeIcon icon={FiTarget} className="w-5 h-5 flex-shrink-0" />
        <span className="font-black text-center leading-tight">
          Reserve My Marketing Seat
          <br />
          <span className="text-sm font-bold">Only {seatsLeft} Left!</span>
        </span>
        <SafeIcon icon={FiArrowRight} className="w-5 h-5 flex-shrink-0" />
      </motion.button>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-red-900 to-black relative overflow-hidden">
      {/* Premium Background Pattern - Mobile Optimized */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-red-400 to-red-600"></div>
        <div className="absolute top-10 left-10 w-48 h-48 sm:w-96 sm:h-96 bg-red-400 rounded-full blur-3xl opacity-10 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 sm:w-80 sm:h-80 bg-red-500 rounded-full blur-3xl opacity-10 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] sm:w-[600px] sm:h-[600px] bg-gradient-radial from-red-300 to-transparent opacity-5 animate-spin-slow"></div>
      </div>

      {/* Mobile Sticky Button */}
      <StickyButton />

      {/* Main Content with Bottom Padding for Sticky Button */}
      <div className="pb-24">
        {/* Hero Section - Mobile Optimized */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4">
          {/* Premium Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-red-900 to-black"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-red-500/10"></div>
          
          {/* Mobile Floating Elements */}
          <FloatingElement delay={0}>
            <div className="absolute top-16 left-6 w-3 h-3 sm:w-4 sm:h-4 bg-red-400 rounded-full blur-sm opacity-60"></div>
          </FloatingElement>
          <FloatingElement delay={2}>
            <div className="absolute top-32 right-8 w-4 h-4 sm:w-6 sm:h-6 bg-red-500 rounded-full blur-sm opacity-40"></div>
          </FloatingElement>
          <FloatingElement delay={4}>
            <div className="absolute bottom-32 left-8 w-2 h-2 sm:w-3 sm:h-3 bg-red-300 rounded-full blur-sm opacity-50"></div>
          </FloatingElement>

          <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-4 sm:space-y-6"
            >
              {/* Mobile Premium Trust Badges */}
              <div className="flex flex-wrap justify-center gap-2 mb-4 sm:mb-6">
                <div className="bg-gradient-to-r from-red-400/20 to-red-500/20 backdrop-blur-sm border border-red-400/30 rounded-full px-3 py-1 text-red-300 text-xs font-bold">
                  <SafeIcon icon={FiTarget} className="inline mr-1 w-3 h-3" />
                  2000+ Marketing Success
                </div>
                <div className="bg-gradient-to-r from-red-400/20 to-red-500/20 backdrop-blur-sm border border-red-400/30 rounded-full px-3 py-1 text-red-300 text-xs font-bold">
                  <SafeIcon icon={FiDollarSign} className="inline mr-1 w-3 h-3" />
                  ₹50+ Crore Revenue
                </div>
                <div className="bg-gradient-to-r from-red-400/20 to-red-500/20 backdrop-blur-sm border border-red-400/30 rounded-full px-3 py-1 text-red-300 text-xs font-bold">
                  <SafeIcon icon={FiBot} className="inline mr-1 w-3 h-3" />
                  AI Marketing Bot
                </div>
              </div>

              {/* Mobile Premium Headline */}
              <div className="space-y-2 sm:space-y-4">
                <motion.h1 
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-red-300 to-red-500 leading-tight px-2"
                  style={{
                    textShadow: '0 0 30px rgba(239, 68, 68, 0.5)',
                  }}
                >
                  AI Agents-ஆல் உங்கள் Digital
                </motion.h1>
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.6 }}
                  className="text-3xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-2 sm:mb-4"
                  style={{
                    textShadow: '0 0 20px rgba(255, 255, 255, 0.5)',
                  }}
                >
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500">Marketing-ஐ</span> 15X பண்ணுங்கள்
                </motion.div>
              </div>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
                className="text-lg sm:text-2xl md:text-3xl text-gray-300 max-w-4xl mx-auto leading-relaxed px-2 font-medium"
              >
                <span className="text-red-400 font-bold">Digital Marketers & Freelancers-க்கு:</span> AI-ன் மூலம் 
                <span className="text-red-400 font-bold"> More Appointments, More Sales</span> அடையுங்கள்!
              </motion.p>

              {/* Mobile Premium Workshop Schedule */}
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.2 }}
                className="bg-gradient-to-r from-red-500/10 to-red-600/10 backdrop-blur-lg border border-red-400/30 rounded-2xl p-4 sm:p-6 max-w-sm mx-auto shadow-2xl"
              >
                <div className="flex items-center justify-center gap-2 mb-3">
                  <div className="w-10 h-10 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiCalendar} className="w-5 h-5 text-white" />
                  </div>
                  <p className="text-red-400 font-bold text-base">Digital Marketing AI Workshop</p>
                </div>
                <div className="text-white text-center space-y-1">
                  <div className="text-xl font-black text-red-400">This Sunday</div>
                  <div className="text-base text-gray-300">10:00 AM - 1:00 PM IST</div>
                  <div className="text-xs text-red-400 font-medium bg-red-400/10 rounded-full px-3 py-1 inline-block">
                    Limited to 60 Digital Marketing Professionals
                  </div>
                </div>
              </motion.div>

              {/* Mobile Premium Countdown Timer */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.5 }}
                className="bg-gradient-to-r from-orange-600/20 to-red-600/20 backdrop-blur-lg border-2 border-orange-400/50 rounded-2xl p-4 sm:p-6 max-w-xs mx-auto shadow-2xl"
              >
                <div className="flex items-center justify-center gap-1 mb-3">
                  <SafeIcon icon={FiClock} className="w-5 h-5 text-orange-400" />
                  <p className="text-orange-400 font-bold text-sm text-center">🚨 Marketing Bonuses Expire In:</p>
                </div>
                <div className="grid grid-cols-2 gap-3 text-center">
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-3 border border-orange-400">
                    <div className="text-2xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                    <div className="text-xs text-orange-200 uppercase font-bold">Minutes</div>
                  </div>
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-3 border border-orange-400">
                    <div className="text-2xl font-black text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                    <div className="text-xs text-orange-200 uppercase font-bold">Seconds</div>
                  </div>
                </div>
                <div className="text-xs text-orange-300 mt-3 font-medium text-center">Worth ₹1,63,000+ Marketing AI Tools!</div>
              </motion.div>

              {/* Mobile Premium CTA */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.8 }}
                className="space-y-4 px-2"
              >
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleRegistration}
                  className="bg-gradient-to-r from-red-600 via-red-700 to-red-800 text-white font-black py-5 px-8 rounded-2xl text-lg shadow-2xl border-4 border-red-300 w-full relative overflow-hidden mobile-btn"
                >
                  <span className="relative z-10 flex items-center justify-center gap-2">
                    <SafeIcon icon={FiTarget} className="w-5 h-5" />
                    My Marketing Success Seat-ஐ Book பண்ணுங்கள்
                    <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shimmer"></div>
                </motion.button>
                
                <div className="flex flex-col items-center gap-2">
                  <div className="text-orange-400 font-bold text-lg text-center">
                    ⚠️ Only {seatsLeft} Marketing Seats Remaining!
                  </div>
                  <div className="text-red-400 text-sm font-medium text-center">
                    Join 2000+ Successful Digital Marketing Professionals
                  </div>
                </div>
              </motion.div>

              {/* Mobile Premium Guarantee */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 2.1 }}
                className="flex justify-center px-2"
              >
                <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 border-2 border-green-400/50 rounded-full px-4 py-2 text-green-300 text-sm font-bold backdrop-blur-sm text-center">
                  <SafeIcon icon={FiShield} className="inline mr-1 w-4 h-4" />
                  100% Digital Marketing Success Guarantee
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Mobile Premium Problem & Solution Section */}
        <section className="py-12 sm:py-20 bg-gradient-to-b from-black to-red-900 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-red-600/5"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <div className="space-y-8 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-12 lg:items-start">
              {/* Problems - Mobile Optimized */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="space-y-6"
              >
                <h2 className="text-2xl sm:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-500 mb-6 text-center lg:text-left">
                  உங்கள் Digital Marketing-ல இந்த Problems இருக்கா?
                </h2>
                
                <div className="space-y-4">
                  {[
                    { problem: "Client appointments குறைவா இருக்கு & sales conversion drop", icon: FiCalendar },
                    { problem: "Lead qualification & follow-ups manually handle பண்ணணும்", icon: FiUsers },
                    { problem: "24/7 client support & marketing consultation கொடுக்க முடியலை", icon: FiHeadphones },
                    { problem: "Campaign management & performance tracking difficult", icon: FiBarChart3 },
                    { problem: "Competition-ல behind ஆகி clients lose ஆகுது", icon: FiTrendingUp }
                  ].map((item, index) => (
                    <motion.div 
                      key={index}
                      initial={{ opacity: 0, x: -30 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      className="flex items-start gap-3 p-4 bg-gradient-to-r from-orange-500/10 to-red-500/10 border border-orange-400/30 rounded-xl backdrop-blur-sm hover:border-orange-400/50 transition-all"
                    >
                      <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                        <SafeIcon icon={item.icon} className="text-white w-5 h-5" />
                      </div>
                      <p className="text-gray-300 text-base font-medium leading-snug">{item.problem}</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Solutions - Mobile Optimized */}
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="space-y-6"
              >
                <h2 className="text-2xl sm:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-6 text-center lg:text-left">
                  AI Marketing Solutions Ready!
                </h2>
                
                <div className="space-y-4">
                  {[
                    { solution: "24/7 AI marketing assistant for lead qualification & consultation", icon: FiBot, multiplier: "24/7 Active" },
                    { solution: "Automated appointment booking & client pipeline management", icon: FiCalendar, multiplier: "Zero Miss" },
                    { solution: "Instant campaign analysis, ROI reports & strategy suggestions", icon: FiBarChart3, multiplier: "Real-time" },
                    { solution: "Smart lead scoring & automated follow-up sequences", icon: FiTarget, multiplier: "Auto-Qualify" },
                    { solution: "WhatsApp & Email integration for seamless client communication", icon: FiMessageCircle, multiplier: "Omnichannel" }
                  ].map((item, index) => (
                    <motion.div 
                      key={index}
                      initial={{ opacity: 0, x: 30 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      className="flex items-start gap-3 p-4 bg-gradient-to-r from-red-500/10 to-red-600/10 border border-red-400/30 rounded-xl backdrop-blur-sm hover:border-red-400/50 transition-all group"
                    >
                      <div className="w-10 h-10 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                        <SafeIcon icon={item.icon} className="text-white w-5 h-5" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-300 text-base font-medium mb-2 leading-snug">{item.solution}</p>
                        <span className="inline-block bg-gradient-to-r from-red-400 to-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                          {item.multiplier}
                        </span>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Mobile Premium Social Proof Section */}
        <section className="py-12 sm:py-20 bg-gradient-to-b from-red-900 to-black relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500/3 to-red-600/3"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-6">
                Digital Marketing Success Stories
              </h2>
              <div className="grid grid-cols-3 gap-4 max-w-md mx-auto">
                <div className="bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-400/30 rounded-xl px-3 py-3">
                  <div className="text-xl sm:text-3xl font-black text-red-400">2000+</div>
                  <div className="text-gray-300 font-medium text-xs sm:text-sm">Marketers</div>
                </div>
                <div className="bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-400/30 rounded-xl px-3 py-3">
                  <div className="text-xl sm:text-3xl font-black text-red-400">₹50+ Cr</div>
                  <div className="text-gray-300 font-medium text-xs sm:text-sm">Revenue</div>
                </div>
                <div className="bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-400/30 rounded-xl px-3 py-3">
                  <div className="text-xl sm:text-3xl font-black text-red-400">99%</div>
                  <div className="text-gray-300 font-medium text-xs sm:text-sm">Success</div>
                </div>
              </div>
            </motion.div>

            <div className="space-y-6 sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-6 sm:space-y-0">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gradient-to-b from-gray-800/50 to-red-900/50 backdrop-blur-lg border border-red-400/20 rounded-2xl p-6 shadow-2xl hover:border-red-400/40 transition-all"
                >
                  {/* Rating Stars */}
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <SafeIcon key={i} icon={FiStar} className="w-4 h-4 text-red-400 fill-current" />
                    ))}
                  </div>
                  
                  {/* Results */}
                  <div className="mb-4">
                    <div className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500">
                      {testimonial.result}
                    </div>
                    <div className="text-gray-400 text-sm mb-2">in {testimonial.period}</div>
                    <div className="inline-block bg-gradient-to-r from-red-400 to-red-500 text-white text-xs font-bold px-2 py-1 rounded-full mb-2">
                      {testimonial.multiplier}
                    </div>
                    <div className="text-red-300 text-xs font-medium">{testimonial.experience}</div>
                  </div>
                  
                  {/* Quote */}
                  <blockquote className="text-gray-300 mb-4 italic text-sm leading-relaxed">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  {/* Author */}
                  <div className="border-t border-gray-700 pt-4">
                    <div className="font-bold text-white text-base">{testimonial.name}</div>
                    <div className="text-red-400 text-sm font-medium">{testimonial.role}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Mobile Premium Curriculum Section */}
        <section className="py-12 sm:py-20 bg-gradient-to-b from-black to-red-900 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-red-600/5"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-4">
                3 Hours = Marketing Transformation
              </h2>
              <p className="text-lg text-gray-300 font-medium">Complete AI Marketing System for Professionals</p>
            </motion.div>

            <div className="space-y-6 lg:grid lg:grid-cols-3 lg:gap-6 lg:space-y-0">
              {[
                {
                  hour: "Hour 1",
                  title: "AI Foundation for Marketing",
                  subtitle: "From Manual to AI-Powered",
                  icon: FiZap,
                  color: "from-orange-500 to-red-600",
                  items: [
                    "AI marketing bot setup for lead qualification",
                    "WhatsApp & Email automation for clients", 
                    "Marketing funnel integration with AI",
                    "Client preference tracking & analysis"
                  ]
                },
                {
                  hour: "Hour 2", 
                  title: "Client Acquisition & Conversion",
                  subtitle: "Maximize Your Appointments",
                  icon: FiTarget,
                  color: "from-red-500 to-red-600",
                  items: [
                    "Automated appointment booking & scheduling",
                    "Smart lead scoring & qualification systems",
                    "Campaign performance tracking & optimization",
                    "Client communication automation & follow-ups"
                  ]
                },
                {
                  hour: "Hour 3",
                  title: "Scale & Automate Marketing",
                  subtitle: "Build Your Marketing Empire",
                  icon: FiCrown,
                  color: "from-red-600 to-red-700",
                  items: [
                    "Multi-client management system automation",
                    "Advanced analytics and ROI reporting",
                    "Team collaboration and client handoffs",
                    "Long-term marketing business growth strategies"
                  ]
                }
              ].map((module, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-gradient-to-b from-gray-800/50 to-red-900/50 backdrop-blur-lg border border-red-400/20 rounded-2xl p-6 shadow-2xl hover:border-red-400/40 transition-all"
                >
                  <div className="text-center mb-6">
                    <div className={`w-16 h-16 bg-gradient-to-r ${module.color} rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg`}>
                      <SafeIcon icon={module.icon} className="w-8 h-8 text-white" />
                    </div>
                    <div className="text-sm font-bold text-red-400 mb-2">{module.hour}</div>
                    <h3 className="text-xl font-black text-white mb-2">{module.title}</h3>
                    <p className="text-red-400 font-bold text-base">{module.subtitle}</p>
                  </div>
                  
                  <ul className="space-y-3">
                    {module.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start gap-2">
                        <div className="w-5 h-5 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <SafeIcon icon={FiCheck} className="text-white w-3 h-3" />
                        </div>
                        <span className="text-gray-300 font-medium text-sm leading-snug">{item}</span>
                      </li>
                    ))}
                  </ul>
                </motion.div>
              ))}
            </div>

            {/* Mobile Premium Learning Outcomes */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mt-12 bg-gradient-to-r from-red-500/20 to-red-600/20 backdrop-blur-lg border-2 border-red-400/30 rounded-2xl p-6 text-center"
            >
              <h3 className="text-2xl sm:text-3xl font-black text-red-400 mb-6">Workshop முடிஞ்சதும் உங்ககிட்ட இருக்கும்:</h3>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                  { outcome: "Complete AI marketing system", icon: FiBot },
                  { outcome: "Automated client pipeline", icon: FiUsers },
                  { outcome: "24/7 lead qualification", icon: FiTarget },
                  { outcome: "Marketing automation tools", icon: FiZap }
                ].map((item, index) => (
                  <div key={index} className="flex flex-col items-center gap-2 bg-gradient-to-b from-red-400/10 to-red-500/10 border border-red-400/30 rounded-xl p-4">
                    <div className="w-10 h-10 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center">
                      <SafeIcon icon={item.icon} className="w-5 h-5 text-white" />
                    </div>
                    <span className="text-white font-bold text-center text-sm leading-tight">{item.outcome}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </section>

        {/* Mobile Premium Bonus Section */}
        <section className="py-12 sm:py-20 bg-gradient-to-b from-red-900 to-black relative overflow-hidden">
          {/* Premium Background Effects */}
          <div className="absolute inset-0">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-red-500/10 to-red-600/10"></div>
            <FloatingElement delay={0}>
              <div className="absolute top-20 left-20 w-24 h-24 sm:w-32 sm:h-32 bg-red-400/20 rounded-full blur-2xl"></div>
            </FloatingElement>
            <FloatingElement delay={3}>
              <div className="absolute bottom-20 right-20 w-32 h-32 sm:w-40 sm:h-40 bg-red-500/20 rounded-full blur-2xl"></div>
            </FloatingElement>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-6">
                ₹1,63,000+ Marketing AI Tools - FREE!
              </h2>
              <div className="text-4xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500 mb-8">
                Total Value: ₹4,50,000+
              </div>
              
              {/* Mobile Premium Bonus Timer */}
              <div className="bg-gradient-to-r from-orange-600/30 to-red-600/30 backdrop-blur-lg border-2 border-orange-400/50 rounded-2xl p-6 max-w-sm mx-auto shadow-2xl">
                <div className="flex items-center justify-center gap-2 mb-4">
                  <SafeIcon icon={FiClock} className="w-6 h-6 text-orange-400" />
                  <p className="text-orange-400 font-black text-lg">⏰ Marketing Bonuses Expire In:</p>
                </div>
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-4 border-2 border-orange-400">
                    <div className="text-3xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                    <div className="text-sm text-orange-200 uppercase font-bold">Minutes</div>
                  </div>
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-4 border-2 border-orange-400">
                    <div className="text-3xl font-black text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                    <div className="text-sm text-orange-200 uppercase font-bold">Seconds</div>
                  </div>
                </div>
              </div>
            </motion.div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {bonuses.map((bonus, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className={`bg-gradient-to-b from-gray-800/60 to-red-900/60 backdrop-blur-lg border-2 ${
                    bonus.premium ? 'border-red-400/50 shadow-red-400/20' : 'border-gray-600/50'
                  } rounded-2xl p-6 shadow-2xl hover:border-red-400/70 transition-all group relative overflow-hidden`}
                >
                  {/* Premium Badge */}
                  {bonus.premium && (
                    <div className="absolute top-3 right-3">
                      <div className="bg-gradient-to-r from-red-400 to-red-500 text-white text-xs font-black px-2 py-1 rounded-full flex items-center gap-1">
                        <SafeIcon icon={FiTarget} className="w-3 h-3" />
                        MARKETING VIP
                      </div>
                    </div>
                  )}

                  <div className="text-center">
                    <div className={`w-16 h-16 ${
                      bonus.premium 
                        ? 'bg-gradient-to-r from-red-400 to-red-500 shadow-red-400/50' 
                        : 'bg-gradient-to-r from-gray-600 to-gray-700'
                    } rounded-full flex items-center justify-center mx-auto mb-4 shadow-2xl`}>
                      <SafeIcon icon={bonus.icon} className={`w-8 h-8 ${bonus.premium ? 'text-white' : 'text-white'}`} />
                    </div>
                    
                    <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white text-sm font-black py-1 px-3 rounded-full inline-block mb-3">
                      FREE BONUS
                    </div>
                    
                    <h3 className="text-lg font-black text-white mb-3">{bonus.title}</h3>
                    <div className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500 mb-3">
                      {bonus.value}
                    </div>
                    <p className="text-gray-400 text-sm leading-relaxed">{bonus.description}</p>
                  </div>

                  {/* Shimmer Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -skew-x-12 animate-shimmer opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Mobile Premium About Instructor */}
        <section className="py-12 sm:py-20 bg-gradient-to-b from-black to-red-900 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-red-600/5"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <div className="space-y-8 lg:grid lg:grid-cols-2 lg:gap-12 lg:items-start lg:space-y-0">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="relative"
              >
                <div className="relative group">
                  {/* Mobile Premium Image Container */}
                  <div className="w-full h-72 sm:h-80 lg:h-[420px] rounded-2xl overflow-hidden shadow-2xl border-4 border-red-400/30 group-hover:border-red-400/50 transition-all">
                    <img 
                      src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759040594802-Abdul%20Hakkim.webp" 
                      alt="Abdul Hakkim - Digital Marketing AI Expert"
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="w-full h-full bg-gradient-to-br from-red-100 to-red-200 rounded-2xl flex items-center justify-center" style={{display: 'none'}}>
                      <div className="text-center">
                        <div className="w-24 h-24 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-2xl">
                          <span className="text-3xl font-black text-white">AH</span>
                        </div>
                        <div className="text-xl font-black text-gray-900">Abdul Hakkim</div>
                        <div className="text-gray-700 font-medium">Marketing AI Expert</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Mobile Premium Floating Badges */}
                  <div className="absolute -bottom-4 -left-4 bg-gradient-to-r from-red-400 to-red-500 rounded-full p-3 shadow-2xl">
                    <SafeIcon icon={FiTarget} className="w-6 h-6 text-white" />
                  </div>
                  <div className="absolute -top-4 -right-4 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full p-3 shadow-2xl">
                    <SafeIcon icon={FiDollarSign} className="w-6 h-6 text-white" />
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="space-y-6"
              >
                <div className="text-center lg:text-left">
                  <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-4">
                    Meet Your Marketing AI Mentor
                  </h2>
                  <div className="text-xl font-bold text-white">Abdul Hakkim</div>
                  <div className="text-lg text-red-400 font-medium">Digital Marketing AI Transformation Expert</div>
                </div>
                
                {/* Mobile Premium Stats */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {[
                    { metric: "₹50+ Crore", label: "Marketing Revenue", icon: FiDollarSign },
                    { metric: "2000+", label: "Marketers Trained", icon: FiUsers },
                    { metric: "5 Years", label: "Marketing AI", icon: FiCrown }
                  ].map((stat, index) => (
                    <motion.div 
                      key={index}
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      className="bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-400/30 rounded-xl p-4 text-center backdrop-blur-sm hover:border-red-400/50 transition-all"
                    >
                      <div className="w-10 h-10 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center mx-auto mb-2">
                        <SafeIcon icon={stat.icon} className="w-5 h-5 text-white" />
                      </div>
                      <div className="text-xl font-black text-red-400">{stat.metric}</div>
                      <div className="text-sm text-gray-400 font-medium">{stat.label}</div>
                    </motion.div>
                  ))}
                </div>

                {/* Mobile Premium Story */}
                <div className="space-y-4 text-gray-300 text-base leading-relaxed">
                  <p className="bg-gradient-to-r from-gray-800/50 to-red-900/50 border border-red-400/20 rounded-xl p-4 backdrop-blur-sm">
                    <span className="text-red-400 font-bold">"Digital Marketing AI Revolution"</span> என் passion. 
                    2000+ marketers & freelancers-ஐ AI-ன் மூலம் 15X growth achieve பண்ண help பண்ணியிருக்கேன். 
                  </p>
                  <p className="bg-gradient-to-r from-gray-800/50 to-red-900/50 border border-red-400/20 rounded-xl p-4 backdrop-blur-sm">
                    <span className="text-green-400 font-bold">"Proven marketing systems"</span> - lead generation, client acquisition, campaign optimization 
                    எல்லாத்தையும் <span className="text-red-400 font-bold"> AI-powered marketing tools</span>-ல convert பண்ணி teach பண்ணுவேன்.
                  </p>
                  <p className="text-center text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-400/30 rounded-xl p-4">
                    "உங்க marketing business-ஐ next level-க்கு கொண்டுபோக ready!"
                  </p>
                </div>

                {/* Mobile Premium Credentials */}
                <div className="flex flex-col sm:flex-row gap-3">
                  <div className="flex items-center gap-2 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-400/30 rounded-full px-4 py-2 justify-center">
                    <SafeIcon icon={FiCheck} className="w-4 h-4 text-green-400" />
                    <span className="text-green-300 font-bold text-sm">2000+ Marketing Success Stories</span>
                  </div>
                  <div className="flex items-center gap-2 bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-400/30 rounded-full px-4 py-2 justify-center">
                    <SafeIcon icon={FiTarget} className="w-4 h-4 text-red-400" />
                    <span className="text-red-300 font-bold text-sm">Marketing AI Pioneer</span>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Mobile Premium FAQ Section */}
        <section className="py-12 sm:py-20 bg-gradient-to-b from-red-900 to-black relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500/3 to-red-600/3"></div>
          <div className="relative z-10 max-w-4xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-4">
                Digital Marketing Common Questions
              </h2>
              <p className="text-lg text-gray-400">எல்லா doubts-ம் clear பண்ணிக்கோங்கள்</p>
            </motion.div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gradient-to-r from-gray-800/50 to-red-900/50 backdrop-blur-lg border border-red-400/20 rounded-xl shadow-xl hover:border-red-400/40 transition-all"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full px-4 sm:px-6 py-4 text-left flex justify-between items-center hover:bg-red-400/5 rounded-xl transition-all"
                  >
                    <span className="font-bold text-white text-base pr-4 leading-snug">{faq.question}</span>
                    <div className="flex items-center gap-2">
                      <SafeIcon 
                        icon={FiChevronDown} 
                        className={`w-5 h-5 text-red-400 transition-transform flex-shrink-0 ${
                          openFaq === index ? 'rotate-180' : ''
                        }`} 
                      />
                    </div>
                  </button>
                  
                  <AnimatePresence>
                    {openFaq === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden"
                      >
                        <div className="px-4 sm:px-6 pb-4 text-gray-300 text-base leading-relaxed border-t border-red-400/20 pt-4">
                          {faq.answer}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Mobile Premium Final CTA Section */}
        <section className="py-12 sm:py-20 bg-gradient-to-br from-red-900 via-black to-red-900 relative overflow-hidden">
          {/* Premium Background Effects */}
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-600/10"></div>
            <FloatingElement delay={0}>
              <div className="absolute top-10 left-10 w-24 h-24 sm:w-32 sm:h-32 bg-red-400/20 rounded-full blur-2xl"></div>
            </FloatingElement>
            <FloatingElement delay={2}>
              <div className="absolute bottom-10 right-10 w-32 h-32 sm:w-40 sm:h-40 bg-red-500/20 rounded-full blur-2xl"></div>
            </FloatingElement>
            <FloatingElement delay={4}>
              <div className="absolute top-1/2 left-1/4 w-20 h-20 sm:w-24 sm:h-24 bg-red-300/15 rounded-full blur-xl"></div>
            </FloatingElement>
          </div>

          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 leading-tight">
                Ready to 15X Your Marketing Revenue?
              </h2>

              <p className="text-xl text-gray-300 font-medium max-w-2xl mx-auto">
                <span className="text-red-400 font-bold">3 மணி நேரத்தில்</span> உங்கள் marketing business-ஐ transform பண்ணுங்கள்!
              </p>

              {/* Mobile Final Premium Timer */}
              <div className="bg-gradient-to-r from-orange-600/30 to-red-600/30 backdrop-blur-lg border-2 border-orange-400/50 rounded-2xl p-6 max-w-xs mx-auto shadow-2xl">
                <p className="text-orange-400 font-black text-lg mb-4">⏰ Last Chance - Marketing Bonuses Expire:</p>
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-4 border-2 border-orange-400">
                    <div className="text-3xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                    <div className="text-sm text-orange-200 uppercase font-bold">Minutes</div>
                  </div>
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-4 border-2 border-orange-400">
                    <div className="text-3xl font-black text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                    <div className="text-sm text-orange-200 uppercase font-bold">Seconds</div>
                  </div>
                </div>
              </div>

              <div className="space-y-4 px-2">
                <div className="bg-gradient-to-r from-orange-500/20 to-red-500/20 border-2 border-orange-400/50 rounded-xl p-4 max-w-sm mx-auto">
                  <div className="text-orange-400 font-black text-xl mb-2">
                    🚨 FINAL WARNING
                  </div>
                  <div className="text-white font-bold text-lg">
                    Only {seatsLeft} Marketing Seats Left!
                  </div>
                  <div className="text-gray-300 text-sm mt-2">
                    Workshop starts in few hours. Don't miss this opportunity!
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleRegistration}
                  className="bg-gradient-to-r from-red-600 via-red-700 to-red-800 text-white font-black py-6 px-12 rounded-2xl text-xl shadow-2xl border-4 border-red-300 w-full relative overflow-hidden mobile-btn"
                  style={{
                    background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 25%, #b91c1c 50%, #dc2626 75%, #ef4444 100%)',
                    backgroundSize: '300% 300%',
                    animation: 'gradient-shift 3s ease infinite'
                  }}
                >
                  <span className="relative z-10 flex items-center justify-center gap-3">
                    <SafeIcon icon={FiTarget} className="w-6 h-6" />
                    YES! Transform My Marketing Business
                    <SafeIcon icon={FiArrowRight} className="w-6 h-6" />
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shimmer"></div>
                </motion.button>

                {/* Mobile Premium Guarantees */}
                <div className="flex flex-col gap-3">
                  <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 border-2 border-green-400/50 rounded-full px-4 py-2 text-green-300 font-bold backdrop-blur-sm text-center">
                    <SafeIcon icon={FiShield} className="inline mr-2 w-4 h-4" />
                    100% Digital Marketing Success Guarantee
                  </div>
                  <div className="flex gap-3">
                    <div className="flex-1 bg-gradient-to-r from-orange-500/20 to-red-500/20 border-2 border-orange-400/50 rounded-full px-3 py-2 text-orange-300 font-bold backdrop-blur-sm text-center text-sm">
                      <SafeIcon icon={FiLock} className="inline mr-1 w-4 h-4" />
                      Secure Payment
                    </div>
                    <div className="flex-1 bg-gradient-to-r from-red-500/20 to-red-600/20 border-2 border-red-400/50 rounded-full px-3 py-2 text-red-300 font-bold backdrop-blur-sm text-center text-sm">
                      <SafeIcon icon={FiTarget} className="inline mr-1 w-4 h-4" />
                      Marketing-Only
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed">
                Join 2000+ digital marketing professionals who transformed their business with AI. 
                <span className="text-red-400 font-bold"> Your marketing empire starts today!</span>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Mobile Premium Footer */}
        <footer className="bg-black border-t border-red-400/20 py-8">
          <div className="max-w-7xl mx-auto px-4">
            <div className="space-y-6 sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-6 sm:space-y-0">
              <div className="text-center sm:text-left">
                <h3 className="text-xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-500 mb-3">
                  Digital Marketing AI Academy
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm">
                  Digital marketers & freelancers-க்கு AI-ன் மூலம் business growth achieve பண்ண உதவும் exclusive academy.
                </p>
              </div>
              
              <div className="text-center sm:text-left">
                <h4 className="text-lg font-bold text-white mb-4">Marketing Support</h4>
                <div className="space-y-3 text-gray-400">
                  <div className="flex items-center gap-2 justify-center sm:justify-start">
                    <div className="w-8 h-8 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center">
                      <SafeIcon icon={FiPhone} className="w-4 h-4 text-white" />
                    </div>
                    <span className="font-medium text-sm">+91 9884899080</span>
                  </div>
                  <div className="flex items-center gap-2 justify-center sm:justify-start">
                    <div className="w-8 h-8 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center">
                      <SafeIcon icon={FiMail} className="w-4 h-4 text-white" />
                    </div>
                    <span className="font-medium text-sm">support@yinguru.com</span>
                  </div>
                </div>
              </div>

              <div className="text-center sm:text-left lg:col-span-1 sm:col-span-2 lg:col-span-1">
                <h4 className="text-lg font-bold text-white mb-4">Legal</h4>
                <div className="space-y-2 text-gray-400 text-sm">
                  <div><a href="https://funnelsdone.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-red-400 transition-colors font-medium">Terms & Conditions</a></div>
                  <div><a href="https://funnelsdone.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-red-400 transition-colors font-medium">Privacy Policy</a></div>
                  <div><a href="https://funnelsdone.com/refund-policy" target="_blank" rel="noopener noreferrer" className="hover:text-red-400 transition-colors font-medium">Refund Policy</a></div>
                </div>
              </div>
            </div>
            
            {/* Mobile Premium Disclaimer */}
            <div className="border-t border-gray-800 mt-6 pt-6">
              <div className="text-xs text-gray-500 leading-relaxed mb-4 bg-gray-900/50 rounded-xl p-4 border border-gray-800">
                <strong className="text-red-400">Disclaimer:</strong> This site is not a part of the Facebook™ website or Facebook™ Inc. Additionally, This site is NOT endorsed by Facebook™ in any way. FACEBOOK™ is a trademark of FACEBOOK™, Inc. Results shown are from digital marketing professionals but individual results may vary based on effort and implementation. We provide proven AI strategies and tools designed specifically for digital marketers and freelancers, but your success depends on your commitment to applying what you learn.
              </div>
              <div className="text-center text-gray-400">
                <p className="font-medium text-sm">&copy; 2024 Digital Marketing AI Academy. All rights reserved.</p>
                <p className="text-xs mt-2 text-red-400">Transforming Digital Marketing through AI Innovation</p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;